export default __webpack_public_path__ + "fc383e71ded460254cc7e0dd9268530b.svg";